import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useRedeemHistoryQuery, useVmdDeleteRedeemMutation, useVmdModifyRedeemMutation } from "src/api/redeemAPI";
import { useAppSelector } from "src/store/actions/action";
import { getPathValue } from "src/utils/queryStringUtil";
import Slider from "react-slick";
import cn from "classnames";
import Body from "src/components/common/Body";
import Button from "src/components/common/Button";
import IconButton from "src/components/common/IconButton";
import List from "src/components/common/List";
import RedeemDetailItem from "src/components/notice/RedeemDetailItem";
import RedeemProcessItem from "src/components/filter/RedeemProcessItem";
import BottomModal from "src/components/common/BottomModal";
import { RefProps } from "src/components/common/BottomModal";
import styled from "styled-components";
import SVG from "src/utils/SVG";
import {
  setContext,
  setFulFillId,
  setModifiedList,
  setModifyId,
  setRedeemDataAllInit,
  setRedeemImageList,
  setRedeemDataInit,
} from "../../store/reducers/redeemReduce";

function redeemDetail() {
  const navigate = useNavigate();
  const redeemIdx: any = getPathValue(); // 이행번호
  const userInfo = useAppSelector((state) => state.userReduce.userInfo, shallowEqual);
  const dispatch = useDispatch();
  const [redeemInfo, setRedeemInfo] = useState<any>({
    title: "",
    category: "",
    confirm: "",
    storeId: "",
    re_execute_idx: "",
    execute_idx: "",
  });
  const [redeemListReverse, setRedeemListReverse] = useState<any>();
  const [currentIdx, setCurrentIdx] = useState<number>(0);

  // ================================================================================================
  // API 영역
  // ================================================================================================
  const redeemHistory = useRedeemHistoryQuery(redeemIdx, { skip: false });
  const [vmdModifyRedeem] = useVmdModifyRedeemMutation();
  const [vmdDeleteRedeem] = useVmdDeleteRedeemMutation();
  const selectedImage = useAppSelector((state) => state.redeemReduce);
  useEffect(() => {
    if (redeemHistory.isSuccess) {
      setCurrentIdx(redeemHistory.data.data.re_execute.length - 1);
      setRedeemInfo({
        title: redeemHistory.data.data.notice_title,
        category: redeemHistory.data.data.category_name,
        confirm: redeemHistory.data.data.confirm_yn,
        storeId: redeemHistory.data.data.store_id,
        re_execute_idx: redeemHistory.data.data.re_execute[0].re_execute_idx,
        execute_idx: redeemHistory.data.data.re_execute[0].execute_idx,
      });
      setRedeemListReverse([...redeemHistory.data.data.re_execute].reverse());
    }
  }, [redeemHistory]);

  // 헤더 메뉴더보기
  const processModalRef = React.useRef<RefProps>(null);

  const openProcessModal = () => {
    if (processModalRef.current) processModalRef.current.modalOpen();
  };

  useEffect(() => {
    if (redeemHistory?.data?.data.re_execute[0].execute_idx !== undefined) {
      dispatch(setFulFillId({ fulfillId: redeemHistory.data.data.re_execute[0].execute_idx }));
    }
    if (redeemHistory?.data?.data.re_execute[0].re_execute_idx !== undefined) {
      dispatch(setModifyId({ modifyId: redeemHistory.data.data.re_execute[0].re_execute_idx }));
    }
    if (redeemHistory?.data?.data.re_execute[0].deficient_reason !== undefined) {
      dispatch(setContext({ context: redeemHistory?.data?.data.re_execute[0].deficient_reason }));
    }
    if (redeemHistory?.data?.data.re_execute[0].deficient_img_image !== undefined) {
      dispatch(setRedeemImageList({ imageList: [redeemHistory.data.data.re_execute[0].deficient_img_image] }));
    }
    if (redeemHistory?.data?.data.re_execute[0].reExecuteImages[0] !== undefined) {
      dispatch(setModifiedList({ modifiedList: [redeemHistory.data.data.re_execute[0].reExecuteImages[0]] }));
    } else {
      //220921 wjp 재이행 요청 수정(이미지 제거 시 필요)
      dispatch(setModifiedList({ modifiedList: [] }));
    }
  }, [redeemHistory]);

  const fulfillProcessBtn = async (code: string) => {
    if (code === "U") {
      dispatch(setRedeemDataInit());
      // 수정하기
      const data = {
        images: "",
        execute_contents: "",
      };
      // navigate("/fulfill-Register/" + fulfillDetail.data.notice_idx, { state: { modify: true, fulfillId: fulfillDetail.data.execute_idx } });
      navigate("/redeem-request", { state: { mode: "MODIFY" } });
    } else if (code === "D") {
      // 삭제하기
      if (confirm("등록된 재이행 요청을 삭제하시겠습니까?")) {
        await vmdDeleteRedeem({ re_execute_idx: redeemInfo.re_execute_idx });
        navigate("/fulfill-detail/" + redeemInfo.execute_idx, { replace: true });
      }
    }
  };

  const handleIdx = (idx: number) => {
    setCurrentIdx(idx);
  };

  const back = () => {
    dispatch(setRedeemDataAllInit());
    navigate(-1);
  };
  const sendReRedeem = () => {
    if (redeemHistory?.data?.data.re_execute) {
      const reRedeemImage = redeemHistory?.data?.data.re_execute[0].reExecuteImages.find((temp: any) => temp.type == "E");
      dispatch(setRedeemImageList({ imageList: [reRedeemImage] }));
      dispatch(setModifiedList({ modifiedList: [] }));
      dispatch(setContext({ context: "" }));
    }
    navigate("/redeem-request", { state: { mode: "REREDEEM", originalId: redeemHistory.data.data.re_execute[0].origin_img_idx } });
  };

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => back()}>
            재이행 이력
          </Button>
        </div>

        <div className="btn-box">
          {userInfo.user_type === "E" && redeemListReverse && redeemListReverse[0].execute_yn === "N" && (
            <>
              <IconButton btnName="메뉴더보기" className="more" onClick={openProcessModal}>
                <SVG name="more" />
              </IconButton>
            </>
          )}
        </div>
      </header>
      <Body type="detail">
        <TitleBox>
          <p className="cate">{redeemInfo.category}</p>
          <p className="title">{redeemInfo.title}</p>
        </TitleBox>

        {redeemListReverse && redeemListReverse.length > 1
          ? redeemListReverse
              .map((v: any, i: number) => {
                return (
                  <RedeemLinkList>
                    // 재이행 이력 1회 이상시 노출, 클릭시 이전 데이터 호출
                    <li className={cn({ active: i === currentIdx })} key={i}>
                      <span onClick={() => handleIdx(i)}>재이행{i === 0 ? "" : i + 1}</span>
                    </li>
                  </RedeemLinkList>
                );
              })
              .reverse()
          : ""}

        {redeemListReverse && (
          <RedeemDetailItem
            data={redeemListReverse[currentIdx]}
            confirm={redeemInfo.confirm}
            storeId={redeemInfo.storeId}
            executeIdx={redeemInfo.execute_idx}
            sendReRedeem={sendReRedeem}
            redeemIdx={currentIdx}
            redeemLength={redeemListReverse.length}
          />
        )}
      </Body>

      <BottomModal modalTitle="재이행 관리" ref={processModalRef}>
        <List pd="0 15px">
          <RedeemProcessItem onClick={(v: string) => fulfillProcessBtn(v)} />
        </List>
      </BottomModal>
    </>
  );
}

const TitleBox = styled.div`
  padding: 30px 15px 0;
  .cate {
    font-size: 12px;
  }
  .title {
    padding: 8px 0 16px;
    border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
    ${({ theme }) => theme.textOverflow.singleLine()}
    color: #000000;
    font-size: 16px;
    font-weight: 700;
  }
`;

const RedeemLinkList = styled.ul`
  overflow: hidden;
  overflow-x: scroll;
  width: 100%;
  padding: 0 15px;
  margin-top: 24px;
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "center", "nowrap")}
  > li {
    flex: 0 0 auto;
    margin-right: 8px;
    &:last-child {
      margin-right: 0;
    }
    > span {
      display: inline-block;
      padding: 5px 15px;
      border: 1px solid ${({ theme }) => theme.color.linePrimary};
      border-radius: 15px;
    }
    &.active {
      > span {
        border-color: ${({ theme }) => theme.color.main};
        color: ${({ theme }) => theme.color.main};
        background-color: #ddf3fa;
      }
    }
  }
`;

const ModalImgSlide = styled.div`
  height: 100%;
  background: #ccc;
`;

const StyledSlider = styled(Slider)`
  .slick-track {
    height: 100%;
  }
  .slick-slide {
    height: 100%;
    ${({ theme }) => theme.flexBox.flexMixin("column", "center", "center")}
    > div {
      width: 100%;
      height: auto;
      overflow-y: scroll;
    }
    .img-box {
      padding-top: 0;
      text-align: center;
      > img {
        position: initial;
        top: 0;
        left: 0;
        transform: none;
      }
      > .video-wrap {
        position: initial;
        top: 0;
        left: 0;
        transform: none;
      }
    }
  }
  .slick-list {
    background: rgba(0, 0, 0, 0.5);
  }
`;

export default redeemDetail;
